import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { Button } from 'react-toolbox/lib/button'

import CollapseIcon from './CollapseIcon'

import styles from './styles.scss'

const CollapseButton = (props) => {
  const { collapse, onClick } = props
  return (
    <Flex column styleName='expandButton'>
      <Button
        onClick={onClick}
        icon={<CollapseIcon collapse={collapse}/>}
      />
    </Flex>
  )
}

CollapseButton.propTypes = {
  collapse: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
}

CollapseButton.defaultProps = {
  collapse: false
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(CollapseButton)
